import React from "react";

export default function Preliminary(props) {
  return (
    <div>
      <h1 className="text-3xl font-bold mb-6 text-yellow-500">Preliminary</h1>

      <div className="space-y-5">
        <div className="rounded-xl p-6 bg-white border border-gray-200 shadow-sm">
          <span className="text-gray-700">
            This Policy states the internal policy of the Slum Soccer ("SS")
            with regard to the definition, prohibition, prevention, and
            redressal of sexual harassment of women at its workplace.
          </span>
        </div>

        <div className="rounded-xl p-6 bg-white border border-gray-200 shadow-sm">
          <span className="text-gray-700">
            Slum Soccer has zero tolerance against sexual harassment and is
            committed to creating and maintaining a safe and secure workplace,
            free from impropriety, indignity and fear, for all persons,
            particularly women.
          </span>
        </div>

        <div className="rounded-xl p-6 bg-white border border-gray-200 shadow-sm">
          <h2 className="text-xl font-bold text-gray-800 mb-4">
            Applicability
          </h2>
          <span className="text-gray-700 block mb-1">
            The scope of this policy encompasses all persons who are engaged by
            SS for any work/activities or are associated with work/activities of
            SS in any capacity, including:
          </span>

          <ul className="space-y-2 mb-4">
            <li className="flex items-start">
              <span className="text-yellow-500 mr-2 ">•</span>
              <span className="text-gray-700">
                Staff who are on rolls (full time, part time, adhoc basis).
              </span>
            </li>
            <li className="flex items-start">
              <span className="text-yellow-500 mr-2 ">•</span>
              <span className="text-gray-700">
                Trainees, interns, volunteers, Fellows.
              </span>
            </li>
            <li className="flex items-start">
              <span className="text-yellow-500 mr-2 ">•</span>
              <span className="text-gray-700">
                Consultants, Persons on contract (either directly or through an
                agent, including a contractor, with or without the knowledge of
                the principal employer).
              </span>
            </li>
          </ul>

          <span className="text-gray-700 block mb-4">
            All above are hereinafter collectively mentioned as ‘Employees’ in
            this policy document for the sake of brevity irrespective of whether
            they may be working on a voluntary basis or otherwise as well as
            whether their terms of employment and/ or association with SS are
            express or implied.
          </span>

          <span className="text-gray-700 block mb-1">
            In addition, the provisions of the policy would also apply to :
          </span>

          <ul className="space-y-1 mb-4">
            <li className="flex items-start">
              <span className="text-yellow-500 mr-2 ">•</span>
              <span className="text-gray-700">
                Suppliers, vendors, visitors, invitees, etc.
              </span>
            </li>
            <li className="flex items-start">
              <span className="text-yellow-500 mr-2 ">•</span>
              <span className="text-gray-700">
                Board and society members of Krida Vikas Sanstha.
              </span>
            </li>
          </ul>

          <span className="text-gray-700 block">
            They are hereinafter collectively mentioned as ‘Associates’.
          </span>
        </div>

        <div className="rounded-xl p-6 bg-white border border-gray-200 shadow-sm">
          <h2 className="text-xl font-bold text-gray-800 mb-4">Objective</h2>
          <span className="text-gray-700">
            The objective of the Policy is to prohibit and prevent sexual
            harassment of any women employee or associate staff at its workplace
            and provide them with an appropriate redressal mechanism should an
            incident of sexual harassment take place.
          </span>
        </div>

        <div className="rounded-xl p-6 bg-white border border-gray-200 shadow-sm">
          <h2 className="text-xl font-bold text-gray-800 mb-4">
            Definitions for the Policy
          </h2>
          <ul className="space-y-2 mb-4">
            <li className="flex items-start">
              <span className="text-yellow-500 mr-2 ">a)</span>
              <span className="text-gray-700">
                <u>Complainant</u>: means a woman of any age who alleges to have
                been subjected to any act of sexual harassment by the
                respondent. It is further clarified that complainant means the
                aggrieved woman (and not any other person who, in certain
                exceptional situations, has submitted the complaint on her
                behalf).
              </span>
            </li>
            <li className="flex items-start">
              <span className="text-yellow-500 mr-2 ">b)</span>
              <span className="text-gray-700">
                <u>Woman</u>, for the purpose of this policy, means woman as
                well as Trans-Woman.
              </span>
            </li>
            <li className="flex items-start">
              <span className="text-yellow-500 mr-2 ">c)</span>
              <span className="text-gray-700">
                <u>Respondent</u>: means a person against whom the complainant
                has made a complaint of sexual harassment
              </span>
            </li>
          </ul>
        </div>

        <div className="rounded-xl p-6 bg-[#efc94c] text-white font-bold">
          <p>
            This Policy is guided by the Sexual Harassment of Women at Workplace
            (Prevention, Prohibition and Redressal) Act, 2013.{" "}
          </p>
        </div>

        <div className="mt-8 text-sm text-gray-500 italic">
          <p>
            It may be noted that the allegation of sexual harassment depends on
            the experience of the aggrieved person, and not on the intentions of
            the respondent. In other words, it is the impact and not the intent
            that matters.{" "}
          </p>
        </div>
      </div>
    </div>
  );
}
